import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { SimpleAuthenticator } from "./SimpleAuthenticator"
import Layout from "../Layout/Layout"


function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component"
}


export function withAuth(WrappedComponent) {
  /*
  HOC that provides auth state and user to child components
  */
  class WithAuth extends Component {
    constructor(props) {
      super(props)
      this.state = {
        navOpen: true,
        isClient: false
      }
    }

    componentDidMount() {
      this.setState({isClient: true})
    }

    render() {
      let {isClient} = this.state
      if (!isClient) {
        return <></>
      }
      return (
        <>
          {this.props.user ?
            <WrappedComponent {...this.props}/> :
            <Layout key={isClient} showNav={false} forceLight={true}>
              <SimpleAuthenticator/>
            </Layout>
          }
        </>
      )
    }
  }

  WithAuth.displayName = `WithAuth(${getDisplayName(WrappedComponent)})`

  WithAuth.propTypes = {
    user: PropTypes.object
  }

  const mapStateToProps = state => ({
    user: state.user
  })

  return connect(mapStateToProps)(WithAuth)
}


export default withAuth
